module.exports = __webpack_public_path__ + "1f0acec5fd2f8ce3fa1c1edc790ca02e.mp4";